import React from 'react';

import type { View } from 'common/types/view';
import InteractiveUser from 'common/types/users/interactiveUser';

import WatchAssetModal from './components/WatchAssetModal';
import { WatchProvider } from './context';

export function WatchAssetManager({
  view,
  onDismiss,
  currentUser,
}: {
  currentUser: InteractiveUser;
  view: View;
  onDismiss: () => void;
}) {
  return (
    <WatchProvider>
      <WatchAssetModal fourfour={view.id} onDismiss={onDismiss} currentUser={currentUser} view={view} />
    </WatchProvider>
  );
}
